import React from 'react'
import ViewIndividualMemberForm from '../../features/ViewIndividualMemberForm/ViewIndividualMemberForm'

const ViewIndividualMember = () => {
  return (
    <div>
      <ViewIndividualMemberForm />
    </div>
  )
}

export default ViewIndividualMember